import { DatePipe, UpperCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  Optional,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCalendarTimes,
  faStopwatch,
} from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@univacity/angular/datas';
import { AngularUiModule } from '@univacity/angular/ui';
import { Option, RoutePath, Session, Tour } from '@univacity/shared/types';
import { format, isFuture } from 'date-fns';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'un-tour-booking-selection',
  imports: [
    DatePipe,
    UpperCasePipe,
    ReactiveFormsModule,
    FontAwesomeModule,
    AngularUiModule,
  ],
  templateUrl: './tour-booking-selection.component.html',
  styleUrls: ['./tour-booking-selection.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourBookingSelectionComponent implements OnInit {
  @Input() tour: Tour;
  private readonly nzModalData?: { tour: Tour } = inject(NZ_MODAL_DATA, {
    optional: true,
  });

  form: FormGroup;
  RoutePath = RoutePath;
  faStopwatch = faStopwatch;
  faClendarTimes = faCalendarTimes;
  sessions: Option[] = [];

  get session() {
    return this.form?.get('session')?.value as Session;
  }
  get total() {
    const { adult, child, infant, student } = this.form.value.guest;
    const p =
      this.tour.onSales && this.tour.sales
        ? this.tour.sales
        : this.tour.pricing;
    return (
      p.adult * adult +
      p.child * child +
      p.infant * infant +
      p.student * student
    );
  }
  constructor(
    public auth: AuthService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    @Optional() private modal?: NzModalRef
  ) {}

  ngOnInit(): void {
    if (this.nzModalData?.tour) this.tour ??= this.nzModalData.tour;
    const {
      adult = 1,
      child = 0,
      infant = 0,
      student = 0,
    } = this.route.snapshot.queryParams;
    this.sessions = this.tour.sessions
      .filter((s) => isFuture(new Date(s.deadline)))
      .map((s) => ({
        label: `${format(new Date(s.start), 'dd/MM/yyyy')} - ${s.title}`,
        value: s,
      }));

    this.form = this.fb.group({
      session: [this.sessions[0]?.value, [Validators.required]],
      guest: [{ adult, student, child, infant }],
    });
  }

  book() {
    const {
      session: { _id },
      guest,
    } = this.form.value;
    this.router.navigate([RoutePath.tours, this.tour._id, RoutePath.checkout], {
      queryParams: {
        ...guest,
        session: _id,
      },
    });
    if (this.modal) this.modal.close();
  }
}
